export default __webpack_public_path__ + "static/media/icon-close.160b0110.svg";